import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class LayerService {

  constructor(private http: HttpClient) { }

  public async getLayerServiceInfo(layerElem: any) {
    // Get the layer's info from the rest endpoint
    //console.log("**get layerServiceInfo for layerElem: " + layerElem.name);

    if ((layerElem.visibleLayersArr !== undefined && layerElem.visibleLayersArr[0] !== undefined) ||
        layerElem.layerType !== 'map-image') {
        let layerElemUrl = layerElem.url + '?f=pjson';
        if (layerElem.token) {
            layerElemUrl = layerElemUrl + '&token=' + layerElem.token;
        }

        if (layerElem.layerType === 'map-image') {
            layerElemUrl = layerElem.url + '/' + layerElem.visibleLayersArr[0] + '?f=pjson';
            if (layerElem.token) {
                layerElemUrl = layerElemUrl + '&token=' + layerElem.token;
            }
        }
        if (layerElem.renderer === undefined || layerElem.rendererType === undefined) {
            // console.log("Get layer info from rest endpoint for : " + layerElemUrl);
            try {
              const returnValue: any = await this.http.get(layerElemUrl).toPromise();
              if (returnValue !== undefined) {
                  // && returnValue.drawingInfo != undefined && returnValue.drawingInfo.renderer != undefined
                  // && returnValue.drawingInfo.renderer.type != undefined) {
                  // Set layer properties from the service and add them to the AGSLayer
                  // unless the config file already set these properties.
                  if (!layerElem.name ) {
                      layerElem.name = returnValue.name;
                  }
                  if (!layerElem.displayField ) {
                      layerElem.displayField = returnValue.displayField;
                  }
                  if (!layerElem.id) {
                      layerElem.id = returnValue.id;
                  }
                  if (returnValue.minScale && returnValue.minScale > 0 ) {
                    if (!layerElem.minScale || returnValue.minScale < layerElem.minScale) {
                        layerElem.minScale = returnValue.minScale;
                    }
                  }
                  if (returnValue.maxScale && returnValue.maxScale > 0 ) {
                    if (!layerElem.maxScale || returnValue.maxScale > layerElem.maxScale) {
                        layerElem.maxScale = returnValue.maxScale;
                    }
                  }
                  if (!layerElem.geometryType) {
                      layerElem.geometryType = returnValue.geometryType;
                  }
                  if (!layerElem.capabilities) {
                      layerElem.capabilities = returnValue.capabilities;
                  }
                  if (!layerElem.supportsAdvancedQueries) {
                      layerElem.supportsAdvancedQueries = returnValue.supportsAdvancedQueries;
                  }
                  if (!layerElem.supportedQueryFormats) {
                      layerElem.supportedQueryFormats = returnValue.supportedQueryFormats;
                  }
                  if (!layerElem.advancedQueryCapabilities) {
                      layerElem.advancedQueryCapabilities = returnValue.advancedQueryCapabilities;
                  }
                  if (!layerElem.description || layerElem.description.length < 1) {
                      layerElem.description = returnValue.description;
                  }
                  if (!layerElem.relationships) {
                      layerElem.relationships = returnValue.relationships;
                  }
                  if (!layerElem.serviceSpatialReference && returnValue.extent
                      && returnValue.extent.spatialReference) {
                      layerElem.serviceSpatialReference = returnValue.extent.spatialReference;
                  }
                  if (returnValue.type) {
                      layerElem.type = returnValue.type;
                  }
                  if (returnValue.hasLabels) {
                      // Layer has labels 
                      layerElem.label = true;
                  } else {
                      // No labels available for this layer
                      layerElem.label = false;
                  } 
                  if (returnValue.drawingInfo !== undefined
                      && returnValue.drawingInfo.renderer !== undefined
                      && returnValue.drawingInfo.renderer.type !== undefined) {
                      if (!layerElem.rendererType ) {
                          layerElem.rendererType = returnValue.drawingInfo.renderer.type;
                      }
                      if (!layerElem.renderer )  {
                          if (layerElem.customRenderer && layerElem.customRenderer.renderer) {
                              // Set drawingInfo to customRenderer property if present in config file for this layer
                              layerElem.renderer = layerElem.customRenderer.renderer;
                          }
                          else {
                            layerElem.renderer = returnValue.drawingInfo.renderer;
                          }
                      }
                
                      if (!layerElem.transparency) {
                          layerElem.transparency = returnValue.drawingInfo.transparency;
                      }
                      if (!layerElem.renderer && layerElem.type === 'feature') {
                      //  _this.setFeatLayerLegendImages(layerElem);
                      }
                  } 
                  
  
                  if (!layerElem.outFields && returnValue.fields && returnValue.fields.length > 0) {
                      const layerFields: any = [];
                      const outFields: any = [];
                      for (const fieldInfo of returnValue.fields) {
                          if (fieldInfo.name) {
                              layerFields.push(fieldInfo);
                              if (fieldInfo.name.toUpperCase() !== 'SHAPE'
                                && !fieldInfo.name.toUpperCase().startsWith('SHAPE_')
                                && fieldInfo.name.toUpperCase() !== 'OBJECTID'
                                && fieldInfo.name.toUpperCase() !== 'GLOBALID'){
                                    outFields.push(fieldInfo.name);
                              }
                          }
                      }
                      layerElem.fields = layerFields;
                      layerElem.outFields = outFields;
                  }
                  // Add fields to queryPickListFields property if none specificed in config file
                  if ((layerElem.nonSelectableArr === undefined || layerElem.nonSelectableArr === "")
                     && !layerElem.queryPickListFields &&
                    returnValue.fields && returnValue.fields.length > 0) {
                    const queryPickListFields: any = [];
                    for (const fieldInfo of returnValue.fields) {
                        if (fieldInfo.name && fieldInfo.name.toUpperCase() !== 'SHAPE' &&
                            !fieldInfo.name.toUpperCase().startsWith('SHAPE_')
                            && fieldInfo.name.toUpperCase() !== 'OBJECTID'
                            && fieldInfo.name.toUpperCase() !== 'GLOBALID') {
                                queryPickListFields.push(fieldInfo.name);
                        }
                    }
                    layerElem.queryPickListFields = queryPickListFields;
                }

                if (!layerElem.serviceLayerName) {
                    layerElem.serviceLayerName = returnValue.name;
                }
                layerElem.serviceMetadataReturned = true;
              }
            } catch (error) {
              console.log('error in getLayerServiceInfo for : '
              + layerElem.serviceLayerID + ' error: ' + JSON.stringify(error));
            }
      }
    } else {
        console.log('In getLayerServiceInfo No visibleLayers for: ' + layerElem.serviceLayerID);
    }
    return (layerElem);

  }

   /**
   * Get service info
   */
  public async getServiceInfo(serviceUrl:string) {
    try {
        return await this.http.get(serviceUrl).toPromise();
    } catch (error) {
        console.log('error in getServiceInfo for : '
        + serviceUrl + ' error: ' + JSON.stringify(error));
    }
  }

}
